import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';

import styles from './CoverImage.module.scss';

interface CoverImageProps {
  src: string;
  title: string;
}

export const CoverImage: React.FC<CoverImageProps> = observer(({ src, title }) => {
  const [hasError, setHasError] = useState<boolean>();

  if (!src || hasError) {
    return <img className={styles['image']} src="/images/project_cover_placeholder.jpg" />;
  }

  return (
    <img className={styles['image']} src={src} alt={title} onError={() => setHasError(true)} />
  );
});
